module.exports = function getResource (label) {
    const resources = { default: 'Par défaut' };

    return resources[label];
};
